import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

import NoItemDifferenceList from './NoItemDifferenceList';

const DesktopDifference = dynamic(() => import('./DesktopDifference'), {
  ssr: true,
});

const MobileDifference = dynamic(() => import('./MobileDifference'), {
  ssr: true,
});

const Difference = ({
  diffData,
  removeDiffData,
}: {
  diffData: any[];
  removeDiffData: (index: number) => void;
}) => {
  const { isDesktop } = useDevice();
  return diffData.length === 0 ? (
    <NoItemDifferenceList />
  ) : (
    <>
      {isDesktop ? (
        <DesktopDifference
          diffData={diffData}
          removeDiffData={removeDiffData}
        />
      ) : (
        <MobileDifference diffData={diffData} removeDiffData={removeDiffData} />
      )}
    </>
  );
};

export default Difference;
